if (!customElements.get('youtube-facade')) {
  customElements.define(
    'youtube-facade',
    class YoutubeFacade extends HTMLElement {
      connectedCallback() {
        this.iframe = this.querySelector('iframe');
        this.poster = this.querySelector('[data-youtube-poster]');

        if (this.poster) {
          if (this.poster.complete) {
            this.#ensurePosterQuality();
          } else {
            this.poster.addEventListener('load', () => this.#ensurePosterQuality(), { once: true });
            this.poster.addEventListener('error', () => this.#useFallbackPoster(), { once: true });
          }
        }

        this.addEventListener('click', this.#activate);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.#activate(event);
          }
        });
      }

      #useFallbackPoster() {
        const fallback = this.poster?.getAttribute('data-fallback-src');
        if (fallback && this.poster.src !== fallback) {
          this.poster.src = fallback;
        }
      }

      #ensurePosterQuality() {
        if (!this.poster) return;
        // YouTube returns a 120x90 placeholder with HTTP 200 when maxresdefault is missing
        if (this.poster.naturalWidth > 0 && this.poster.naturalWidth <= 120) {
          this.#useFallbackPoster();
        }
      }

      #activate = (event) => {
        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }

        if (this.dataset.loaded === 'true' || !this.iframe) return;

        const src = this.iframe.getAttribute('data-src');
        if (!src) return;

        // Setting src on an existing iframe inside the click handler preserves
        // user activation so YouTube can autoplay on the first click.
        this.iframe.setAttribute('src', src);
        this.dataset.loaded = 'true';
        this.classList.add('is-playing');
        this.removeAttribute('tabindex');
        this.removeAttribute('role');
        this.setAttribute('aria-pressed', 'true');
      };
    }
  );
}
